export default {
  // パンくずリスト
  breadcrumb: {
    projectSettings: '設定',
    interviewSettings: '選考設定',
    interviewChannel: '応募チャンネル',
  },

  // リストページ
  pageTitle: '応募チャンネル',
  searchPlaceholder: '応募チャンネルを検索',
  createChannel: '応募チャンネル登録',
  channelName: '応募チャンネル',
  isEnabled: '有効/無効',
  lastEditTime: '最終更新日時',
  lastEditor: '最終更新者',
  createTime: '登録日時',
  creator: '登録者',

  // ダイアログ
  editChannel: '応募チャンネル編集',
  channelNamePlaceholder: '入力してください',
  enabledDescription: '有効化されています。新規登録する際に、このチャネルを選択できます。',
  disabledDescription: '無効のため、新規登録する際に、このチャネルを選択できません',
  addButton: '登録',
  saveButton: '保存',

  // 検証メッセージ
  channelNameRequired: '応募チャンネルを入力してください',

  // 削除確認
  deleteConfirmTitle: '応募チャンネル削除',
  deleteConfirmWarnTitle: '削除できません',
  deleteConfirmContent: '削除すると元に戻せません。応募チャンネル「 {name}」を削除してよろしいですか？',
  deleteUsageWarningContent: 'この応募チャンネルにて登録されている候補者がいるため、既存の候補者を確認してください',

  // 有効化/無効化確認
  enableConfirmTitle: '応募チャンネルを有効にする',
  enableConfirmContent: '有効にすると、新規登録する際に、このチャネルを選択できます。',
  enableButton: '有効',
  disableConfirmTitle: '応募チャンネルを無効にする',
  disableConfirmContent: '無効にすると、候補者を新規登録する際にはこちらの応募チャンネルをを選択できなくなりますが、すでにこちらの応募チャンネルを運用中の候補者には影響しません。',
  disableButton: '無効',

  // 空状態
  emptyStates: {
    noData: {
      title: '応募チャンネルがありません',
      description: 'まず応募チャンネル作成してください',
    },
  },
};
